export default __webpack_public_path__ + "static/media/blue-logout.127772ab.svg";